import { useEffect, useState } from 'react';
import axios from 'src/utils/axios';
import { baseURLStaging } from 'src/config-global';
import GanttViewAssignHours from './GanttViewAssignHours';
import { LoadingScreen } from '../loading-screen';
import './Gantt.css'
import { getData } from './tasks';
import { useData } from 'src/contexts/gantt-chart/gantt-context';

const GanttAssignHours = () => {
  const { data, loading, refreshAssignData,resourseData,assignHours } = useData();
  const [isFirstTime,setIsFirstTime]=useState(true)

  useEffect(() => {
    refreshAssignData()
  }, []);
  useEffect(() => {
    if (!loading) {
      setIsFirstTime(false);
    }
  }, [loading]);
  if (loading && isFirstTime) {
    return <LoadingScreen/>;
  }
  // if (!gantdata) {
  //   return <div>No data available.</div>;
  // }
  let gantData2=getData()
  return (
    <GanttViewAssignHours gantt_resources={resourseData} relaod={() => refreshAssignData()} assignHours={assignHours}/>
  );
};

export default GanttAssignHours;
